import { frontendURL } from '../../../helper/URLHelper';
import VisitasIndex from '../visitas/pages/VisitasIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/informacoes-de-entrada'),
    component: VisitasIndex,
    meta: { referenceAuthenticated: true },
  },
];
